export default "__VITE_ASSET__lLZSI_xU__"